import React, { Component, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Button,
  TabContent,
  TabPane,
} from 'reactstrap';

import useGet from '../../../helpers/hooks/useGet';
import Announcements from './components/Announcements';
import KisanPosts from './components/KisanPosts';
import qs from 'qs';
const Baythak = (props) => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(
    qs.parse(history.location.search, { ignoreQueryPrefix: true }).tab || '1'
  );

  return (
    <React.Fragment>
      <Container fluid>
        <div className='page-content'>
          <div className='align-items-center d-flex justify-content-between mb-3'>
            <h4>Beythak</h4>
            <div>
              <Button
                color={activeTab === '1' ? 'primary' : 'light'}
                className=' waves-effect waves-light mr-1'
                onClick={() => setActiveTab('1')}
              >
                Kisaan Posts
              </Button>
              <Button
                color={activeTab === '2' ? 'primary' : 'light'}
                className=' waves-effect waves-light mr-1'
                onClick={() => setActiveTab('2')}
              >
                Announcements
              </Button>
            </div>
            <Link to='/baythak/create-announcement'>
              {activeTab === '2' && (
                <Button
                  outline
                  color='primary'
                  className=' waves-effect waves-light mr-1'
                >
                  Create Announcement
                </Button>
              )}
            </Link>
          </div>
          <Card>
            <CardBody>
              <TabContent activeTab={activeTab}>
                <TabPane tabId='1'>
                  {activeTab === '1' && <KisanPosts />}
                </TabPane>
                <TabPane tabId='2'>
                  {activeTab === '2' && <Announcements />}
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* <Tabs /> */}
    </React.Fragment>
  );
};

export default Baythak;
